/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAllPaddocksForOfflineQueryResponse, ListAllPaddocksForOfflinePathParams, ListAllPaddocksForOfflineQueryParams, ListAllPaddocksForOffline400, ListAllPaddocksForOffline401, ListAllPaddocksForOffline403, ListAllPaddocksForOffline404, ListAllPaddocksForOffline409, ListAllPaddocksForOffline500 } from "../../types/paddockController/ListAllPaddocksForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAllPaddocksForOffline } from "../../client/paddockController/listAllPaddocksForOffline.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAllPaddocksForOfflineQueryKey = (organizationId: ListAllPaddocksForOfflinePathParams["organizationId"] | undefined, params?: ListAllPaddocksForOfflineQueryParams) => [{ url: '/api/organizations/:organizationId/paddocks/all', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAllPaddocksForOfflineQueryKey = ReturnType<typeof listAllPaddocksForOfflineQueryKey>

export function listAllPaddocksForOfflineQueryOptions(organizationId: ListAllPaddocksForOfflinePathParams["organizationId"] | undefined, params?: ListAllPaddocksForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAllPaddocksForOfflineQueryKey(organizationId, params)
        return queryOptions<ListAllPaddocksForOfflineQueryResponse, ResponseErrorConfig<ListAllPaddocksForOffline400 | ListAllPaddocksForOffline401 | ListAllPaddocksForOffline403 | ListAllPaddocksForOffline404 | ListAllPaddocksForOffline409 | ListAllPaddocksForOffline500>, ListAllPaddocksForOfflineQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAllPaddocksForOffline(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Full non-paginated paddock dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/paddocks/all}
 */
export function useListAllPaddocksForOffline<TData = ListAllPaddocksForOfflineQueryResponse, TQueryData = ListAllPaddocksForOfflineQueryResponse, TQueryKey extends QueryKey = ListAllPaddocksForOfflineQueryKey>(organizationId: ListAllPaddocksForOfflinePathParams["organizationId"] | undefined, params?: ListAllPaddocksForOfflineQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAllPaddocksForOfflineQueryResponse, ResponseErrorConfig<ListAllPaddocksForOffline400 | ListAllPaddocksForOffline401 | ListAllPaddocksForOffline403 | ListAllPaddocksForOffline404 | ListAllPaddocksForOffline409 | ListAllPaddocksForOffline500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAllPaddocksForOfflineQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAllPaddocksForOfflineQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAllPaddocksForOffline400 | ListAllPaddocksForOffline401 | ListAllPaddocksForOffline403 | ListAllPaddocksForOffline404 | ListAllPaddocksForOffline409 | ListAllPaddocksForOffline500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}